import { Box } from "@material-ui/core";
import { useContext } from "react";
import AddressDataComponent from "../../../components/tempo/Shared/AddressDataComponent";
import FormBase from "../../../../forms/FormBase";
import { RecadastramentoContext } from "../../../../context/RecadastramentoContext";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";

export default function BusinessAddressDataStep() {
  const { state, dispatch } = useContext(RecadastramentoContext);

  const onInputAddressChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  return (
    <div>

      <TmpTitleFormCustom marginTop={2} marginBottom={4}>
        Endereço Comercial
      </TmpTitleFormCustom>


      <Box mt={4}>
        <AddressDataComponent
          AddressDataForm={state.BusinessAddressDataForm}
          onInputChange={onInputAddressChange}
        />
      </Box>
    </div>
  );
}
